var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:SourceHanSansCN-Regular;src:url(" + escape(require("./SourceHanSansCN-Regular.eot")) + ");src:url(" + escape(require("./SourceHanSansCN-Regular.eot")) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(require("./SourceHanSansCN-Regular.woff")) + ") format(\"woff\"),url(" + escape(require("./SourceHanSansCN-Regular.ttf")) + ") format(\"truetype\"),url(" + escape(require("./SourceHanSansCN-Regular.svg")) + "#SourceHanSansCN-Regular) format(\"svg\");font-style:normal;font-weight:400}", ""]);

// exports
